import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import he from "./assets/translations/he.json";
import en from "./assets/translations/en.json";

i18n.use(initReactI18next).init({
    resources: {
        he: { translation: he },
        en: { translation: en },
    },
    
    lng: "he",
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});

export default i18n;